import { render, staticRenderFns } from "./ReviewApproval.vue?vue&type=template&id=5fd66b73&"
import script from "./ReviewApproval.vue?vue&type=script&lang=js&"
export * from "./ReviewApproval.vue?vue&type=script&lang=js&"
import style0 from "./ReviewApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports